<template>
  <div class="targetSplit implement_targetSplit">
      <div class="show add">
        <div class="head">
          <img src="~@img/xueyezixun/public/showTitle.png" alt="">
          <p>{{name}}-目标拆分</p>
        </div>
        <div style="margin-bottom: 80px">
          <div style="margin:30px auto">
            <MessageTitle title="学生目标"></MessageTitle>
          </div>
          <div>
            <table>
              <tbody>
                <tr style="background:#F0F9FE ">
                  <th colspan="4"></th>
                </tr>
                <tr>
                  <td class="tableTitle">
                    目标分数
                  </td>
                  <td colspan="2">{{score}}</td>
                </tr>
                <tr>
                  <td class="tableTitle" rowspan="2">目标路径</td>
                  <td colspan="2">{{furtherWay}}</td>
                </tr>
                <tr>
                  <td style="background: none">路径条件</td>
                  <td colspan="2">{{furtherWayNeed}}</td>
                </tr>
                <tr>
                  <td class="tableTitle">目标选科</td>
                  <td colspan="3">{{chooseSubjectName}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="margin-bottom: 80px">
          <div style="margin:30px auto">
            <MessageTitle title="学科差异"></MessageTitle>
          </div>
          <div style="margin: 30px 0">
            <table>
              <tbody>
                <tr style="background:#F0F9FE">
                  <th>科目</th>
                  <th>现阶分数</th>
                  <th>目标分数</th>
                  <th>进步空间</th>
                </tr>
                <tr v-for="(item,key) in difference||[]" :key="key">
                  <td>{{item.name}}</td>
                  <td>{{item.nowMark}}</td>
                  <td>{{item.targetMark}}</td>
                  <td>{{item.targetMark-item.nowMark}}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style="margin-bottom: 80px">
            <div style="margin:30px auto">
              <MessageTitle title="学期目标"></MessageTitle>
            </div>
            <div>
              <div v-for="(item,key) in target||[]" :key="key">
                <div class="gradeTitle">{{item.name}}</div>
                <div style="margin-top: 20px">
                  <CircleName name="学业目标:"></CircleName>
                  <ul class="inputList">
                    <li v-for="(item1,key1) in item.xueye||[]" :key="key1">
                      <span>{{item1.name}}</span>
                      <span>{{item1.value}}</span>
                    </li>
                  </ul>
                </div>
                <div style="margin-top: 20px">
                  <CircleName name="科目目标(分数/名次):"></CircleName>
                  <div class="kemus">
                    <table>
                      <tbody>
                        <tr>
                          <th>学科</th>
                          <th v-for="(item2,key2) in item.kemu" :key="key2">{{item2.name}}</th>
                        </tr>
                        <tr>
                          <th>目标分数</th>
                          <td v-for="(item2,key2) in item.kemu" :key="key2">{{item2.score}}</td>
                        </tr>
                        <tr>
                          <th>目标名次</th>
                          <td v-for="(item2,key2) in item.kemu" :key="key2">{{item2.rank}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div style="margin-top: 20px">
                  <CircleName name="条件目标:"></CircleName>
                  <ul class="inputList" style="background: #F0F9FE;padding: 0 10px;min-height: 100px;margin-bottom: 30px">
                    <li style="width: 100%">
                      <p>{{item.tiaojian}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 80px">
          <div style="margin:30px auto">
            <MessageTitle title="咨询记录"></MessageTitle>
            <div style="background: #F0F9FE;padding:0 10px;margin-top:20px;min-height: 100px">
              {{remark}}
            </div>
          </div>
        </div>
        <div style="text-align: center;margin: 40px auto">
          <Button name="返回" @handleClick="jump"></Button>
        </div>
      </div>
  </div>
</template>

<script>
import MessageTitle from '@/components/xueyezixun/MessageTitle.vue'
import CircleName from "@/components/xueyezixun/CircleName";
import SummaryTitle from "@/components/xueyezixun/SummaryTitle";
import Button from "@/components/xueyezixun/Button";
export default {
  name: "show",
  components:{MessageTitle ,CircleName,SummaryTitle,Button},
  data() {
    return {
      //学科差异
      difference:[],
      target:[],
      remark:'',
      score:"",
      furtherWay:"",
      furtherWayNeed:"",
      chooseSubjectName:"",
      name:"",
    }
  },
  methods:{
    getData(){
      this.$ajax.post(this.G_acapi+ this.ports.consultant.student.mine.implement.chaifenDetail, {
        id:this.$route.query.targetId
      }, {
        headers: {
          token: window.sessionStorage.getItem('ymtxToken')
        }
      }).then((res) => {
        if (res.data.code == 2000) {
              let data=res.data.data
              this.score=data.score;
              this.furtherWay=data.furtherWay;
              this.furtherWayNeed=data.furtherWayNeed;
              this.chooseSubjectName=data.chooseSubjectName;
              this.difference=JSON.parse(data.difference);
              this.target=JSON.parse(data.target);
              this.name=data.name;
              this.remark=data.remark;
        }else{

        }
      })
    },
    jump(){
      let query=JSON.parse(window.sessionStorage.mineStudentData)
      this.$router.push({
        path:'/consultant/minestudent/main/implement/targetsplit',
        query:query
      })
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped lang="less">
@import "./css/index.less";
.bottom{
  text-align: center;
  margin: 30px 0;
}

</style>
<style lang="less">
.implement_targetSplit{
  textarea{
    min-height: 140px !important;
  }
}
</style>